import { createSlice } from "@reduxjs/toolkit";

const settingSlice = createSlice({
    name: "settings",
    initialState: {
        subscription: null,
        trialPeriod: null
    },
    reducers: {
      setSubscription: (state, action) => {
        state.subscription = action?.payload
      },
      setTrialPeriod: (state, action) => {
        state.trialPeriod = action?.payload
      },
      clearSetting: (state, action) => {
        state.subscription = null
        state.trialPeriod = null
      }
    }
  });


// this is for dispatch
export const { setSubscription, setTrialPeriod, clearSetting } = settingSlice.actions;

// this is for configureStore
export default settingSlice.reducer;